// extracted by mini-css-extract-plugin
module.exports = {"annal":"Collect_annal__1gudf","text":"Collect_text__3I7tx"};